const IN_APP_BROWSER_REGEX = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A/i;

const IOS_REGEX = /iPhone|iPad|iPod/i;
const ANDROID_REGEX = /Android/i;

export type InAppBrowserPlatform = 'ios' | 'android' | 'other';

export type InAppBrowserInfo = {
  isInAppBrowser: boolean;
  platform: InAppBrowserPlatform;
};

const NOT_IN_APP: InAppBrowserInfo = { isInAppBrowser: false, platform: 'other' };

const resolvePlatform = (userAgent: string): InAppBrowserPlatform => {
  if (IOS_REGEX.test(userAgent)) return 'ios';
  if (ANDROID_REGEX.test(userAgent)) return 'android';
  return 'other';
};

export const getInAppBrowserInfo = (userAgent?: string): InAppBrowserInfo => {
  const resolvedUserAgent =
    userAgent ?? (typeof window === 'undefined' ? '' : window.navigator.userAgent);

  if (!resolvedUserAgent) return NOT_IN_APP;

  if (!IN_APP_BROWSER_REGEX.test(resolvedUserAgent)) return NOT_IN_APP;

  return {
    isInAppBrowser: true,
    platform: resolvePlatform(resolvedUserAgent),
  };
};

const MENU_GLYPH: Record<InAppBrowserPlatform, string> = {
  ios: '•••',
  android: '⋮',
  other: '',
};

const inAppBrowserExitHint = (platform: InAppBrowserPlatform) =>
  platform === 'other'
    ? 'abra o site no navegador do seu celular'
    : `toque em ${MENU_GLYPH[platform]} no canto da tela e escolha "Abrir no navegador"`;

const inAppBrowserSaveHint = (platform: InAppBrowserPlatform) =>
  `Para salvar o arquivo, ${inAppBrowserExitHint(platform)} e refaça o download por lá.`;

export const inAppBrowserDownloadNotice = (
  platform: InAppBrowserPlatform,
  { otpRequired = false }: { otpRequired?: boolean } = {},
) => {
  if (otpRequired) {
    return `O comprovante vai abrir na tela em vez de baixar. ${inAppBrowserSaveHint(platform)}`;
  }

  const exit = inAppBrowserExitHint(platform);

  if (platform === 'ios') {
    return `O comprovante vai abrir na tela em vez de baixar. Para salvar, ${exit}.`;
  }

  return `Se o download não iniciar, o comprovante abre na tela. Para salvar, ${exit}.`;
};
